import { prop } from '@soltalabs/ramda-extra'
import React, { Component } from 'react'
import { debounce } from 'throttle-debounce'

import { redux } from './redux'
import { JobCardView } from './view'

class JobCardContainer extends Component {
  constructor(props) {
    super(props)

    this.dispatchRecordAssessmentHovered = debounce(
      1500,
      props.dispatchRecordAssessmentHovered
    )

    this.dispatchRecordJobClicked = debounce(1500, props.dispatchRecordJobClicked)
  }

  onAssessmentHovered = () => {
    const { job } = this.props

    this.dispatchRecordAssessmentHovered(job.id)
  }

  onSelectJob = () => {
    const {
      isCard = true,
      job,
      mapContainerRef,
      dispatchSetSelectedJob,
      dispatchSetAddJobLocation,
    } = this.props
    if (isCard) {
      this.dispatchRecordJobClicked(job.id)
    }

    if (!isCard) return

    const viewport = {
      latitude: job.addressLocation.coordinates[1],
      longitude: job.addressLocation.coordinates[0],
      transitionDuration: 500,
    }
    const currentRef = prop('current', mapContainerRef)

    if (currentRef) currentRef.onViewportChange(viewport)

    dispatchSetSelectedJob(job.id)

    dispatchSetAddJobLocation(null)
  }

  onMouseEnterJob = () => {
    const { isCard = true, job, dispatchSetHoveredJob } = this.props
    if (!isCard) return

    dispatchSetHoveredJob(job.id)
  }

  onMouseLeaveJob = () => {
    const { isCard = true, dispatchSetHoveredJob } = this.props
    if (!isCard) return

    dispatchSetHoveredJob(null)
  }

  onDeletingJob = (e) => {
    e.stopPropagation()

    const { mapContainerRef, job, dispatchSetDeletingJob } = this.props

    const viewport = {
      latitude: job.addressLocation.coordinates[1],
      longitude: job.addressLocation.coordinates[0],
      transitionDuration: 500,
    }

    const currentRef = prop('current', mapContainerRef)
    if (currentRef) {
      currentRef.onViewportChange(viewport)
    }

    dispatchSetDeletingJob(job.id)
  }

  onUndoDeleteJob = (e) => {
    e.stopPropagation()
    this.props.dispatchSetDeletingJob(null)
  }

  onDeleteJob = (e) => {
    e.stopPropagation()
    const { job, dispatchSetDeletingJob, dispatchDeleteJob } = this.props
    dispatchSetDeletingJob(job.id)
    dispatchDeleteJob(job.id)
  }

  render() {
    return (
      <JobCardView
        {...this.props}
        onAssessmentHovered={this.onAssessmentHovered}
        onSelectJob={this.onSelectJob}
        onMouseEnterJob={this.onMouseEnterJob}
        onMouseLeaveJob={this.onMouseLeaveJob}
        onDeletingJob={this.onDeletingJob}
        onUndoDeleteJob={this.onUndoDeleteJob}
        onDeleteJob={this.onDeleteJob}
      />
    )
  }
}

const JobCard = redux(JobCardContainer)

export { JobCard }
